var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-white py-4" }, [
    _c("div", { staticClass: "row justify-between align-center px-4" }, [
      _c(
        "span",
        { staticClass: "text-black text-24 font-bold letter-spacing-1" },
        [_vm._v(_vm._s(_vm.$t("uploadImage")))]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "close text-black justify-center row align-center font-bold",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("i", { staticClass: "isif isif-close" })]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row mt-6 justify-center bg-light-gray" },
      [
        _c("vue-avatar", {
          ref: "vueavatar",
          attrs: {
            width: _vm.width,
            height: _vm.height,
            rotation: 0,
            scale: _vm.scale,
            "border-radius": _vm.borderRadius,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row justify-center mt-6 align-center" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.scaleOrigin,
            expression: "scaleOrigin",
          },
        ],
        attrs: { min: _vm.min, max: _vm.max, step: "0.02", type: "range" },
        domProps: { value: _vm.scaleOrigin },
        on: {
          __r: function ($event) {
            _vm.scaleOrigin = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "justify-between mt-6 row align-center px-4" }, [
      _c(
        "button",
        {
          staticClass: "cancel-btn",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("\n      " + _vm._s(_vm.$t("cancel")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "save-btn", on: { click: _vm.saveClicked } },
        [_vm._v("\n      " + _vm._s(_vm.$t("favorites.note.saved")) + "\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }